<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e180"><i>Kimberly</i></p>
<p class="tx2" id="d12e183"><i>May 1851–November 1852</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_ISBNXXXXXXXXX_epub_c5_r1.vue?4f391b8a